import { Dialog, DialogContent, Typography } from '@mui/material';
import PaiLink from 'features/ui/base-components/pai-link';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import PaiButton from '../../ui/base-components/pai-button';

interface Props {
  open: boolean;

  handleClose(): void;

  handleAcceptProjectName(): void;
}

const MaxContactsDialog: React.FC<Props> = ({ open, handleClose, handleAcceptProjectName }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Dialog open={open} classes={{ paper: classes.paper }} fullWidth={true} maxWidth={'sm'}>
      <DialogContent className={classes.content}>
        <Typography className={classes.title}>{t('maxContactsDialogTitle')}</Typography>
        <Typography className={classes.text}>{t('maxContactsDialogText')}</Typography>
      </DialogContent>
      <div className={classes.actions}>
        <PaiLink text={t('back')} size={'sm'} underline={'always'} action={handleClose} />
        <PaiButton text={t('maxContactsDialogAction')} action={handleAcceptProjectName} />
      </div>
    </Dialog>
  );
};

const useStyles = makeStyles()((theme) => ({
  paper: {
    borderRadius: 0,
  },
  content: {
    padding: '24px',
  },
  title: {
    fontSize: theme.typography.pxToRem(18),
    fontWeight: 'bold',
    marginBottom: '24px',
  },
  text: {
    fontSize: theme.typography.pxToRem(15),
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '16px',
    padding: '0 24px 24px 24px',
  },
}));

export default MaxContactsDialog;
